import React from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, MailWarning } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VerifyEmailBanner = () => {
  const { user } = useAuth();
  const [sending, setSending] = React.useState(false);
  const [sent, setSent] = React.useState(false);

  if (!user || user === false || user.email_verified) return null;

  const resend = async () => {
    setSending(true);
    try {
      await axios.post(`${API}/auth/resend-verification`, {}, { withCredentials: true });
      setSent(true);
      toast.success("Verification email sent", { description: `Check ${user.email} (and spam).` });
    } catch (err) {
      toast.error("Couldn't resend", {
        description: err?.response?.data?.detail || "Please try again in a moment.",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      className="rounded-2xl border border-amber-500/25 bg-amber-500/10 p-4 flex flex-col sm:flex-row sm:items-center gap-3"
      data-testid="verify-email-banner"
    >
      <MailWarning className="h-5 w-5 text-amber-400 shrink-0" />
      <p className="text-sm text-amber-200/90 flex-1">
        Confirm your email to unlock the AI studio. We sent a link to{" "}
        <span className="text-amber-100 font-medium">{user.email}</span>.
      </p>
      <button
        onClick={resend}
        disabled={sending || sent}
        className="inline-flex items-center justify-center gap-2 rounded-full border border-amber-500/30 bg-amber-500/10 px-4 py-2 text-xs font-medium text-amber-200 hover:bg-amber-500/20 transition-colors disabled:opacity-60 shrink-0"
        data-testid="verify-email-resend"
      >
        {sending ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : null}
        {sent ? "Sent — check your inbox" : "Resend email"}
      </button>
    </div>
  );
};
